const constants = {
  EXERCISE_WAITING_SELECT: 'EXERCISE_WAITING_SELECT',
};

export default constants;
